// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-wrapper {
	position: relative;
	display: flex;
	flex-direction: column;
	align-self: center;
	align-items: center;
	margin: 1rem;
	width: 100%;
	/* max-height: 250px; */
}
.read-more-less {
	display: flex;
	width: 100%;
	color: var(--secondary-color2);
	justify-content: flex-end;
	align-content: center;
	align-items: center;
	cursor: pointer;
	font-size: 1.5rem;
	margin-bottom: 1rem;
	padding: 0rem 1rem;
	z-index: 5;
}
.lines-container {
	display: flex;
	justify-content: center;
}
.arrows {
	position: absolute;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 100%;
	width: 100%;
	cursor: pointer;
}
.arrows svg {
	filter: drop-shadow(1px 1px 5px white);
	z-index: 5;
}
.lines {
	height: 0.5rem;
	width: 2rem;
	background-color: var(--neutral-color1);
	margin: 1rem 0.5rem;
	z-index: 3;
}
.lines-selected {
	height: 0.5rem;
	width: 2rem;
	background-color: var(--primary-color2);
	margin: 1rem 0.5rem;
	z-index: 3;
}
.lines:hover {
	transform: translate3d(-1px, -1px, 2px);
}
.lines-selected:hover {
	transform: translate3d(-1px, -1px, 2px);
}

.news-container {
	width: 100%;
	border-radius: 0.7rem;
	background-color: var(--primary-color1);
	color: var(--www-color-float-bg1);
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: hidden;
	flex-grow: 0;
}
.news-title {
	height: 50px;
	padding: 0.5rem 1rem;
	display: flex;
	align-items: center;
}
.news-title h1 {
	line-height: 2rem;
	margin: 0;
	margin-top: 1rem;
	text-align: center;
	font-size: 1.4rem;
}

.news-container p {
	line-height: 1.6rem;
	font-size: 1.4rem;
	margin: 2rem;
}
.news-container-img {
	width: 100%;
	padding-top: 60%;
	border-radius: 0.7rem;
	margin: 0;
	background-size: cover;
	background-repeat: no-repeat;
}
.news-container-img h3{
	text-align: center;

}
@media (min-width: 500px) {
	.news-title {
		height: 50px;
	}
	.news-title h1 {
		line-height: 1.5rem;
		font-size: 1.4rem;
	}
	.read-more-less {
		font-size: 1.2rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/LeftPanel/News/News.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,kBAAkB;CAClB,mBAAmB;CACnB,YAAY;CACZ,WAAW;CACX,uBAAuB;AACxB;AACA;CACC,aAAa;CACb,WAAW;CACX,8BAA8B;CAC9B,yBAAyB;CACzB,qBAAqB;CACrB,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,aAAa;CACb,uBAAuB;AACxB;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,YAAY;CACZ,WAAW;CACX,eAAe;AAChB;AACA;CACC,sCAAsC;CACtC,UAAU;AACX;AACA;CACC,cAAc;CACd,WAAW;CACX,uCAAuC;CACvC,mBAAmB;CACnB,UAAU;AACX;AACA;CACC,cAAc;CACd,WAAW;CACX,uCAAuC;CACvC,mBAAmB;CACnB,UAAU;AACX;AACA;CACC,uCAAuC;AACxC;AACA;CACC,uCAAuC;AACxC;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,uCAAuC;CACvC,iCAAiC;CACjC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;CAChB,YAAY;AACb;AACA;CACC,YAAY;CACZ,oBAAoB;CACpB,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,iBAAiB;CACjB,SAAS;CACT,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,YAAY;AACb;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,qBAAqB;CACrB,SAAS;CACT,sBAAsB;CACtB,4BAA4B;AAC7B;AACA;CACC,kBAAkB;;AAEnB;AACA;CACC;EACC,YAAY;CACb;CACA;EACC,mBAAmB;EACnB,iBAAiB;CAClB;CACA;EACC,iBAAiB;CAClB;AACD","sourcesContent":[".news-wrapper {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-self: center;\n\talign-items: center;\n\tmargin: 1rem;\n\twidth: 100%;\n\t/* max-height: 250px; */\n}\n.read-more-less {\n\tdisplay: flex;\n\twidth: 100%;\n\tcolor: var(--secondary-color2);\n\tjustify-content: flex-end;\n\talign-content: center;\n\talign-items: center;\n\tcursor: pointer;\n\tfont-size: 1.5rem;\n\tmargin-bottom: 1rem;\n\tpadding: 0rem 1rem;\n\tz-index: 5;\n}\n.lines-container {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n.arrows {\n\tposition: absolute;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\theight: 100%;\n\twidth: 100%;\n\tcursor: pointer;\n}\n.arrows svg {\n\tfilter: drop-shadow(1px 1px 5px white);\n\tz-index: 5;\n}\n.lines {\n\theight: 0.5rem;\n\twidth: 2rem;\n\tbackground-color: var(--neutral-color1);\n\tmargin: 1rem 0.5rem;\n\tz-index: 3;\n}\n.lines-selected {\n\theight: 0.5rem;\n\twidth: 2rem;\n\tbackground-color: var(--primary-color2);\n\tmargin: 1rem 0.5rem;\n\tz-index: 3;\n}\n.lines:hover {\n\ttransform: translate3d(-1px, -1px, 2px);\n}\n.lines-selected:hover {\n\ttransform: translate3d(-1px, -1px, 2px);\n}\n\n.news-container {\n\twidth: 100%;\n\tborder-radius: 0.7rem;\n\tbackground-color: var(--primary-color1);\n\tcolor: var(--www-color-float-bg1);\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\toverflow: hidden;\n\tflex-grow: 0;\n}\n.news-title {\n\theight: 50px;\n\tpadding: 0.5rem 1rem;\n\tdisplay: flex;\n\talign-items: center;\n}\n.news-title h1 {\n\tline-height: 2rem;\n\tmargin: 0;\n\tmargin-top: 1rem;\n\ttext-align: center;\n\tfont-size: 1.4rem;\n}\n\n.news-container p {\n\tline-height: 1.6rem;\n\tfont-size: 1.4rem;\n\tmargin: 2rem;\n}\n.news-container-img {\n\twidth: 100%;\n\tpadding-top: 60%;\n\tborder-radius: 0.7rem;\n\tmargin: 0;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n}\n.news-container-img h3{\n\ttext-align: center;\n\n}\n@media (min-width: 500px) {\n\t.news-title {\n\t\theight: 50px;\n\t}\n\t.news-title h1 {\n\t\tline-height: 1.5rem;\n\t\tfont-size: 1.4rem;\n\t}\n\t.read-more-less {\n\t\tfont-size: 1.2rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
